/** @module CostScenario/GroupOperationCostsView */
define([
	"dojo/_base/declare",
	"csi/table/Widget",
	"./_GroupCostsMixin"
], function(declare,Widget,_GroupCostsMixin) {

	return declare([Widget, _GroupCostsMixin], {
	});
});